'use strict';

angular.module('app.addAdvertiserToAgency', [])
	.controller('addAdvertiserToAgencyCtrl', ['$scope', '$http', '$rootScope', 'addAdvertiserToAgencyService',
		function ($scope, $http, $rootScope, addAdvertiserToAgencyService) {

		    $scope.advertiserList = [];
		    $scope.advertisers.forEach(function(val){
		        $scope.advertiserList.push(val);
		    })

		    $scope.save = function(){
		        var varAdvertisers = function () {
		            var array = [];
		            $scope.advertiserToBeAdded.forEach(function(id){
		                array.push(id);
		            })
		            return array;
		        }

		        var params = {};
		        params.advertisers = varAdvertisers();
		        params.remove = $scope.advertiserToBeDeleted;
		        params.governingAgencyId = $scope.company_id;

		        addAdvertiserToAgencyService.addAdvertiserToAgency(params, true)
		    		.then(function(response) {
		    			response.data.forEach(function(val, index){
			                $scope.advertisers.push(val);
			            })

			            for (var i = $scope.advertisers.length - 1; i >= 0; i--) {
			                if ($scope.advertiserToBeDeleted.indexOf($scope.advertisers[i].id) >= 0) {
			                    $scope.advertisers.splice(i, 1);
			                }
			            };
			            
			            //close modal
			            $scope.addAdvertiserToAgencyModalInstance.close(function(){
			                $log.info('Close Modal now');
			            })
		    		}, function(response) {
		    			var errorModalInstance = $modal.open({
		                    scope: $scope,
		                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                    windowClass: 'modal-dialog-mention-error'
		                });
		                $scope.errorModalInstance = errorModalInstance;
		                $scope.errorMessage = response.message;
		    		})
		    }

		    $scope.advertiserToBeAdded = [];
		    $scope.advertiserToBeDeleted = [];

		    //delete item from list
		    $scope.delete = function(index){
		        $scope.advertiserToBeDeleted.push($scope.advertiserList[index].id);
		        $scope.advertiserList.splice(index, 1);
		    }
		    
		    $scope.availableTags = function(val) {
		        return $http.get($rootScope.apiUrl + 'company/autocompleteAdvertiser', {
		            loader: true,
		            params: {
		                find: val
		            }
		        }).then(function(response) {    
		        	return angular.forEach(response.data, function(item) {
                        return {id: item.id, name: item.name};
                    });    
		        });
		    };

		    $scope.afterSelectTag = function(item) {
		        var currentAdvertiserIds = $scope.advertisers.map(function(row) {
		            return row.id;
		        })

		        var newAdvertiserIds = $scope.advertiserToBeAdded;

		        if (currentAdvertiserIds.indexOf(item.id) === -1 && newAdvertiserIds.indexOf(item.id) === -1) {
		            $scope.advertiserToBeAdded.push(item.id);
		            $scope.advertiserList.push(item);
		        } else {
		            $(".modal-dialog .modal-content").effect("shake")
		        }

		        $scope.selectedTag = ""; 
		    }
    
}])
